import { CURR_ENV } from '@/core/constants/appConfig/environment';
import { Logger } from '@/shared/logger/logger';
import { EBundleName } from '@/sources';

export class ScriptHandler {
  private static instance: ScriptHandler | null = null;
  private scriptURL: URL | null = null;

  private constructor() {
    this.initScriptURL();
  }

  private static readonly bundleNameToFileMap: Record<string, string> = {
    [EBundleName.EXAMPLE]: 'wtag-example.js',
    [EBundleName.EXTERNAL_PAGE]: 'wtag-external-page.js',
    [EBundleName.SHOPIFY_CUSTOM_PIXEL]: 'wtag-shpfy-cpx.js',
    [EBundleName.SHOPIFY_DEFAULT]: 'wtag-shpfy.js',
    [EBundleName.SHOPWARE5_DEFAULT]: 'wtag-sw5.js',
    [EBundleName.SHOPWARE6_DEFAULT]: 'wtag-sw6.js',
    [EBundleName.UNKNOWN]: '',
    [EBundleName.VANILLA]: 'wtag-vanilla.js',
    // Add more bundle mappings as needed
  };

  static getInstance(): ScriptHandler {
    if (!ScriptHandler.instance) {
      ScriptHandler.instance = new ScriptHandler();
    }
    return ScriptHandler.instance;
  }

  private static getScriptKey(): string {
    return `wgs_${CURR_ENV}_script`;
  }

  private static getFallbackSrc(): string {
    let scriptUrl = '';
    const bundleFilename = ScriptHandler.bundleNameToFileMap[Logger.bundleName];
    if (bundleFilename && bundleFilename !== EBundleName.UNKNOWN) {
      const scripts = document.querySelectorAll(
        `script[src*="${bundleFilename}"]`,
      );
      if (
        scripts.length > 0 &&
        scripts[0]?.getAttribute('src') &&
        scripts[0]?.getAttribute('src') !== ''
      ) {
        let testUrl = scripts[0].getAttribute('src');
        // verify if can create a valid URL form that src
        try {
          // For relative URLs, prepend the current origin
          if (!testUrl?.startsWith('http')) {
            testUrl =
              window.location.origin +
              (testUrl?.startsWith('/') ? '' : '/') +
              testUrl;
          }
          new URL(testUrl || '');
          if (testUrl) {
            scriptUrl = testUrl;
          }
        } catch (error) {
          Logger.error('Invalid script URL:', testUrl, error);
        }
      }
      return scriptUrl || '';
    }
    return '';
  }

  private initScriptURL(): void {
    if (typeof window === 'undefined') return;

    let scriptUrl = null;

    if (!scriptUrl) {
      scriptUrl =
        document.currentScript?.getAttribute('src') ||
        (window as any)[ScriptHandler.getScriptKey()] ||
        ScriptHandler.getFallbackSrc();
    }
    Logger.info('Script URL:', scriptUrl);
    if (scriptUrl) {
      try {
        this.scriptURL = new URL(scriptUrl, window.location.href);
        Logger.info('Script URL after parsing:', this.scriptURL.toString());
      } catch (error) {
        Logger.error('Invalid script URL:', scriptUrl, error);
      }
    } else {
      Logger.error(
        'Script URL not found for key:',
        ScriptHandler.getScriptKey(),
      );
    }
  }

  getBaseURL(): string {
    return this.scriptURL?.origin || '';
  }

  getSourceUid(): string {
    return (
      this.scriptURL?.searchParams.get('uid') ||
      this.scriptURL?.searchParams.get('shop') ||
      ''
    );
  }

  getURLParams(): URLSearchParams | null {
    return this.scriptURL?.searchParams || null;
  }
}
